module.exports = __webpack_public_path__ + "img/11.471a7ca4.png";